export const URL_BECOME_PARTNER = '/services/become-partner',
    URL_PAYMENTS = '/services/personal_data',
    URL_ARCHIVE = '/archive',
    URL_SPECIAL_OFFERS = '/special_offers',
    URL_ABOUT_BANK = '/about/general',
    URL_BRANCHES = '/branches',
    URL_CAREER = '/career',
    URL_TERMS = '/terms',
    URL_FGVO = '/fgvo',
    URL_CONTACTS = '/contacts',
    URL_SAFETY = '/safety',
    URL_NEWS = '/news',
    URL_SECURITY = '/security',
    URL_PARTNERS = '/forpartners',
    URL_DOWNLOADS_PAGE = '/downloads-page',
    URL_STAKEHOLDERS = '/about/for-stakeholders',
    URL_FACEBOOK = 'https://www.facebook.com/abank.dp.ua',
    URL_X = 'https://twitter.com/abank_ukr?s=11&t=vlfJ2WsCySxf4F_V0-ePYg',
    URL_INSTAGRAM = 'https://www.instagram.com/abank_official/',
    URL_LINKEDIT = 'https://www.linkedin.com/company/53436649/admin/',
    URL_TIKTOK = 'https://www.tiktok.com/@abank_official',
    URL_YOUTUBE = 'https://www.youtube.com/channel/UC5UByAW-8_zgjZoAu8LbvRQ?view_as=subscriber',
    URL_APP_STORE = 'https://apps.apple.com/ua/app/abank24/id1261267716?l=uk',
    URL_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=ua.com.abank',
    URL_APP_GALLERY = 'https://appgallery.huawei.com/app/C102212413?sharePrepath=ag&locale=uk_uk',
    URL_OPEN_BANKING = '/openbanking',
    URL_CRS_FATCA = '/crs-fatca',
    URL_PUBLIC_CONTRACTS = '/public_contracts';
